function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { actions as ppcActions } from '../../../reducers/ppc.reducer';
import Button from '../../common/Button.react';
// import Input from '../common/form/Input.react';
import Label from '../../common/form/Label.react';
import Select from '../../common/form/Select.react';
import ModalHeader from '../../modal/ModalHeader.react';

// TODO :: Stop if app is not in constants
var PageComponentAdd = function PageComponentAdd(_ref) {
  var pageID = _ref.pageID;
  var dispatch = useDispatch();
  var _useState = useState('full-image'),
    _useState2 = _slicedToArray(_useState, 2),
    type = _useState2[0],
    setType = _useState2[1];

  // const { title, type } = form;

  // const isValid = () => {
  // 	return (
  // 		title.length > 0
  // 	);
  // };

  // const updateForm = (key, value) => setForm({ ...form, [key]: value });

  var typeObj = {
    'full-image': 'Single Image',
    'paragraph': 'Paragraph'
    // 'image-slider': 'Image Slider',
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: "Add Page Component"
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal__body"
  }, /*#__PURE__*/React.createElement(Label, {
    label: "Component Type",
    required: true
  }), /*#__PURE__*/React.createElement(Select, {
    value: type,
    onChange: function onChange(_ref2) {
      var sValue = _ref2.sValue;
      return setType(sValue);
    },
    options: Object.keys(typeObj).map(function (x) {
      return {
        sValue: x,
        sLabel: typeObj[x]
      };
    })
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Add",
    apiID: "add-component",
    onClick: function onClick() {
      dispatch({
        type: ppcActions.page,
        payload: {
          formData: {
            pageID: pageID,
            type: type,
            apiID: 'add-component'
          },
          method: 'post',
          route: 'add-page-component'
        }
      });

      // popupsAction({
      // 	formData: form,
      // 	method: 'post',
      // });
    },
    width: "120px"
  })));
};
export default PageComponentAdd;